import { cloneElement, createElement } from "react";
import type { ReactElement } from "react";

import { Icon, primeIcon } from "../icon";
import type { IconName } from "../icon";
import { PAGINATOR_ROWS_SUFFIX } from "./messages";

/**
 * Botão de página do Prime com o ícone do DS no lugar do glifo. O `Paginator` 10.9.8 não lista `firstPageLinkIcon`
 * etc. nas props padrão e as espalharia no `<div>`: o ícone entra pelo `template`, como o Select faz.
 */
const pageLink =
  (name: IconName) =>
  ({ element }: { element: ReactElement }) =>
    cloneElement(element, undefined, createElement(Icon, { name, size: 14 }));

type RowsOption = { label: string; value: number };

const withRowsSuffix = (option: RowsOption): RowsOption => ({
  ...option,
  label: `${option.label}${PAGINATOR_ROWS_SUFFIX}`,
});

const ROWS_DROPDOWN_ICON = primeIcon("chevron-down", 14);

/**
 * Template do Hub, na ordem das demais listagens: relatório "Mostrando X a Y de Z registros" à esquerda e, na ordem do template de
 * Embarcações, primeira, anterior, páginas numeradas, próxima, última e linhas por página ("10 por página"). O Dropdown
 * do seletor é do Prime (dentro de um Fragment); o chevron vira o ícone do DS e cada opção ganha o sufixo.
 */
export const HUB_TEMPLATE = {
  layout:
    "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
  FirstPageLink: pageLink("angle-double-left"),
  PrevPageLink: pageLink("angle-left"),
  NextPageLink: pageLink("angle-right"),
  LastPageLink: pageLink("angle-double-right"),
  RowsPerPageDropdown: ({
    element,
  }: {
    element: ReactElement<{
      children: ReactElement<{
        className?: string;
        dropdownIcon?: unknown;
        options?: RowsOption[];
      }>;
    }> | null;
  }) =>
    element
      ? cloneElement(element.props.children, {
          className: "p-paginator-rpp-options",
          dropdownIcon: ROWS_DROPDOWN_ICON,
          options: element.props.children.props.options?.map(withRowsSuffix),
        })
      : null,
};
